import { useState, useEffect } from "react";
import Btn from './Button';
import External from './Extrenal';
import ReactModal  from 'react-modal';
import { Bell } from 'react-bootstrap-icons';
import reactStringReplace from 'react-string-replace';
import {useConfig} from "../helpers/useConfig";
const Statuses = (props) => {
    const [isOpen, setPopupIsOpen] = useState(false);
    const [url, setUrl] = useState(false);
    const [expanded, setExpanded] = useState(false);
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);
    const {configData, setConfig} = useConfig();
    useEffect(() => {
            const handleResize = () => {
                setScreenWidth(window.innerWidth);
                //alert(window.innerWidth);
    
            };
            
            handleResize();
            window.addEventListener('resize', handleResize);
    
            // Clean up the event listener when the component unmounts
            return () => {
                window.removeEventListener('resize', handleResize);
            };
            
            }, []); // Empty dependency array means this effect runs once on mount
    const toggleOpen = (url) => {
        
        const url_cor = reactStringReplace(url, '&amp;', (match, i) => (
            '&'
          ));
        setUrl(url_cor.join(''));
        setPopupIsOpen(!isOpen);
      }

    function convertCtoF(sentence) {
      return sentence.replace(/(-?\d+(?:\.\d+)?)\s*°/g, (match, celsius) => {
        const f = (parseFloat(celsius) * 9) / 5 + 32;
        return `${f.toFixed(1)}°F`;
      });
    }

    function getStartIcon(url)
    {
      if (url.includes("hum"))
        return "https://v2013.02ws.co.il/images/icons/humidity.svg";
      else if (url.includes("temp"))
        return "https://v2013.02ws.co.il/images/icons/temp.svg";
       else if (url.includes("wind"))
        return "https://v2013.02ws.co.il/images/icons/wind.svg";
       else if (url.includes("dew"))
        return "https://v2013.02ws.co.il/images/icons/dew.svg";
       else if (url.includes("rain"))
        return "https://v2013.02ws.co.il/images/icons/rain.svg";
       else if (url.includes("rad"))
        return "https://v2013.02ws.co.il/images/icons/radiation.svg";
       else if (url.includes("UV"))
        return "https://v2013.02ws.co.il/images/icons/UV.svg";
       else if (url.includes("dust"))
        return "https://v2013.02ws.co.il/images/icons/dust.svg";
       else if (url.includes("bar"))
        return "https://v2013.02ws.co.il/images/icons/pressure.svg";
       
      return "https://v2013.02ws.co.il/images/icons/temp.svg";
    }

    const customStyles = {
        content: {
          width:(screenWidth > 800 ) ? '420px' :'100%',
          padding:'5px',
          inset: (props.lang == 1) ? '0px auto 0px 0px' : '0px  0px 0px auto',
          direction: (props.lang == 1) ? 'rtl' : '',
          position: 'absolute',
          marginRight: '',
          transform: '',
        },
      };
    const isMobile = screenWidth < 500;
    return (
        <>
        <ul id="more_sigweather" className={"modern box_text white_transp_box white_box " + (props.lang == 1? 'rtl textright' : 'textleft')}>
            <li>
            <ul id="sigweather" className="">
                    {props.statuses.map((status, i) => {
                        if (isMobile && !expanded && i > 0) return null;
                        const title = eval(`status.sigtitle${props.lang}`);
                        const ext = eval(`status.sigext${props.lang}`);
                        const icon_start_src = getStartIcon(status.url);
                        const url_with_lang = status.url + "&lang=" + props.lang; 
                    return <li key={i} className="d-flex">
                          <div className="inline mr-auto align-self-center"><img src={icon_start_src} width="30px" height="30px" alt={title} /></div>
                          <div className="mr-auto align-self-center">{title} - {configData.tempUnit == 'F' ? convertCtoF(ext) : ext}</div>
                          <div className="ml-auto align-self-center">
                            <Btn btnOnClick={() => toggleOpen(url_with_lang)}  img={(props.lang == 1)? "CaretLeft" : "CaretRight"} cssClasses="btn-lg">
                            </Btn> 
                            </div>  
                          
                        </li>;
                })}
                
            </ul>
            {isMobile && props.statuses.length > 1 &&
                <li className="d-flex justify-content-center" style={{listStyle:'none'}}>
                    <Btn btnOnClick={() => setExpanded(!expanded)} img={expanded ? "ChevronUp" : "ChevronDown"} cssClasses="" />
                </li>
            }
            </li>
        </ul>
         <ReactModal
        
         isOpen={isOpen}
         contentLabel="Example Modal"
         style={customStyles}
         onRequestClose={() => toggleOpen(false)}
 
       >
          <Btn btnOnClick={() => toggleOpen(false)} btnTitleText={""}  img={"X"} cssClasses={(props.lang == 1? 'float-start' : 'float-end')}>
                 
         </Btn>
         <div className="sidepopup">
          <External src={`https://v2013.02ws.co.il/small/${url}`} width="100%" height="95%" className={props.cssClasses}/>                                   
         </div>
       </ReactModal>
       </>
    );
}

export default Statuses; 